import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'src/app/app.config/app.config';
import { IReportCurrentUser } from 'src/app/model/api/report-current-user';
import { IConversationMessageFile } from '../../model/api/conversation-message-file';  
import { BaseService } from '../base/base.service';

@Injectable({
  	providedIn: 'root'
})
export class ReportCurrentUserService extends BaseService<IReportCurrentUser> {

    protected urlV2 = "/admin-v02/report-current-user";    

    constructor(@Inject(APP_CONFIG) private _config, private _http: HttpClient) {
        super(_config, _http)
    }
}
